import { type MouseEvent, type ReactNode, useRef } from "react";

import { Box, Checkbox, Column } from "@hightouch/htui";

export type CollapsibleProps = {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  children?: ReactNode;
};

export const Collapsible = ({
  label,
  value,
  onChange,
  children,
}: CollapsibleProps) => {
  const checkboxContainer = useRef<HTMLSpanElement>(null);

  const toggle = (event: MouseEvent) => {
    // Ignore clicks on checkbox
    if (checkboxContainer.current?.contains(event.target as HTMLElement)) {
      return;
    }

    onChange(!value);
  };

  return (
    <Box borderColor="base.border" borderRadius="md" borderWidth="hairline">
      <Box
        bg={value ? "green.200" : undefined}
        borderTopRadius="md"
        cursor="pointer"
        display="flex"
        p={6}
        onClick={toggle}
      >
        <span ref={checkboxContainer}>
          <Checkbox
            isChecked={value}
            label={label}
            onChange={(event) => {
              onChange(event.target.checked);
            }}
          />
        </span>
      </Box>

      {value && (
        <Column
          borderColor="base.border"
          borderTopWidth="hairline"
          gap={6}
          p={6}
        >
          {children}
        </Column>
      )}
    </Box>
  );
};

Collapsible.displayName = "Collapsible";
